import { createContext } from 'react';

export const FormConfigContext = createContext(1);
